export interface ProjectGroup {
	name: string;
	company_id: string;
	id: string;
}